import React from 'react';

export const AuthContext = React.createContext({
  token: null,
  userId: null,
  role: null,
  name: null,
  login: (token, userId, role, name) => {},
  logout: () => {},
});
